import Service from '@ember/service';
import config from 'mewe/config';
import CurrentUserStore from 'mewe/stores/current-user-store';
import { ds } from 'mewe/stores/ds';

export default class GlobalsService extends Service {
  apiHost = config.apiHost;
  currentUser = CurrentUserStore.getState();
  ds = ds;

  constructor() {
    super(...arguments);

    CurrentUserStore.getState().deferred.promise.then(() => {
      const user = CurrentUserStore.getState();
      this.currentUser = user;
    });
  }
}
